import script from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"

import "./ProductFilter.vue?vue&type=style&index=0&id=b5e29ab0&lang=scss"

const __exports__ = script;

export default __exports__